import * as React from 'react';
import { Tooltip } from 'antd';
import { FileDoneOutlined } from '@ant-design/icons';
import { cn } from '../../utils/ClassNamesUtils';

// Rounded "tag-pill" (Figma 13154:67101): grey-5 hairline, fully rounded, Body/Regular
// text with an optional 12px leading icon. Background and padding vary per pill, so
// callers pass them through className. Never wider than its container: long text
// truncates with an ellipsis instead of spilling out of the row.
export const OWTagPill = ({
	icon,
	children,
	className,
}: {
	icon?: React.ReactNode;
	children: React.ReactNode;
	className?: string;
}) => (
	<span
		className={cn(
			'bodyregular inline-flex max-w-full shrink-0 items-center gap-2xs whitespace-nowrap rounded-full border border-solid border-grey-5 bg-white px-xs py-xxs text-character-primary',
			className
		)}
	>
		{icon ? <span className="flex shrink-0 text-[12px]">{icon}</span> : null}
		<span className="min-w-0 truncate">{children}</span>
	</span>
);

// Marks which deliverable a task or work order belongs to. Deliverable names have no
// length limit, so the full name is always one hover away when the pill truncates it.
export const DeliverablePill = ({ name }: { name: React.ReactNode }) => (
	<OWTagPill icon={<FileDoneOutlined />} className="bg-character-dangerBg">
		<Tooltip title={name}>
			<span>{name}</span>
		</Tooltip>
	</OWTagPill>
);

export default OWTagPill;
